import { useParams } from "react-router-dom";
import "./certificate.css";
import { getReviewerById } from "src/network/api";
import { useEffect, useState } from "react";
import { STATIC } from "src/network/networkConfig";
import logo from "src/assets/img/logo192.png";

const CertificatePage = () => {
  const [reviewer, setReviewer] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    const fetchReviewer = async () => {
      try {
        setLoading(true);
        const response = await getReviewerById(id);
        setReviewer(response.data.data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReviewer();
  }, [id]);

  if (loading)
    return (
      <div className="d-flex justify-content-center mt-5">
        <div className="loader mt-5"></div>
      </div>
    );
  if (error) return <p>Error: {error}</p>;
  if (!reviewer) return <p>No data available.</p>;

  return (
    <div
      className="certificate-main-container"
      style={{ width: "800px", margin: "20px auto" }}
    >
      <div
        className="pm-certificate-container"
        style={{ backgroundImage: `url("${STATIC.frameImageURL}")` }}
      >
        <div className="pm-certificate-border col-xs-12">
          <div className="logo-container">
            <img src={logo} alt="Logo" className="certificate-logo" />
          </div>
          {/* Certificate Header */}
          <div className="pm-certificate-header">
            <div className="pm-certificate-title cursive col text-center">
              <h2>International Faculty Research and Journal Index</h2>
            </div>
          </div>

          <h1 className="text-center" style={{ fontWeight: "bold" }}>
            CERTIFICATE OF REVIEWING
          </h1>

          {/* Certificate Body */}
          <div className="pm-certificate-body d-flex justify-content-center">
            <div className="pm-certificate-block">
              {/* Certificate Holder's Name */}
              <div className="col-xs-12 text-center">
                <span className="pm-label">
                  THIS CERTIFICATE IS PROUDLY AWARDED TO
                </span>
                <div className="pm-name-container mt-3">
                  <h2 className="pm-name-text bold">
                    {reviewer.name || "N/A"}
                  </h2>
                  <hr className="pm-underline" />
                </div>
              </div>

              {/* Completion Date with Underline */}
              <div className="col-xs-12 text-center position-relative">
                <span
                  className="pm-earned-text block"
                  style={{ textAlign: "justify" }}
                >
                  WE HEREBY NOTIFY THAT THE PERSON ABOVE HAS BEEN SERVING AS A
                  REVIEWER OF IFRJ INDEX. WE ARE GRATEFUL TO{" "}
                  <h6
                    style={{
                      textTransform: "uppercase",
                      margin: 0,
                      display: "inline",
                      fontWeight: "bold",
                    }}
                  >
                    {reviewer.name}
                  </h6>{" "}
                  FOR REVIEWING JOURNAL QUALITY FOR YEAR{" "}
                  {new Date().getFullYear()}.
                </span>
                <div className="logo-bottom-right">
                  <p className="issuer-text">Issuer: Team IFRJ Index</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificatePage;
